import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DashWidgetsComponent } from './dash-widgets.component';
import { SharedModule } from '../../../../shared/shared.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { NgxSortableModule } from 'ngx-sortable';
import { OrganizationService } from 'app/services/organization/organization.service';
import { DialogDashWidgetSortModule } from './dialog-dash-widget-sort/dialog-dash-widget-sort.module';

@NgModule({
    imports: [
        SharedModule,
        MatDialogModule,
        MatMenuModule,
        NgxSortableModule,
        DialogDashWidgetSortModule,
        MatIconModule,
    ],
    declarations: [DashWidgetsComponent],
    exports: [DashWidgetsComponent],
    providers: [
        OrganizationService,
    ],
})
export class DashWidgetsModule
{
}
